import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';
import { FeedbackButton } from '../../components/feedbackButton';
import { VersionDisplay } from '../../components/versionDisplay';
const CONTAINER_CSS = css `
  margin: 5px;
  color: #aaaaaa;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
`;
export const Footer = () => {
    return (_jsxs("div", { css: CONTAINER_CSS, children: [_jsxs("div", { children: [_jsx(FeedbackButton, { variant: 'outlined', withMargin: false }), _jsxs(Typography, { component: 'div', variant: 'caption', children: [_jsx(Link, { to: '/terms', children: "Terms & Conditions" }), " / ", _jsx(Link, { to: '/privacy-policy', children: "Privacy Policy" }), " / Emojis by", ' ', _jsx("a", { href: 'https://twemoji.twitter.com/', target: '_blank', rel: 'noreferrer', children: "Twitter" })] })] }), _jsxs("div", { children: [_jsx(VersionDisplay, {}), _jsxs(Typography, { component: 'div', variant: 'caption', children: ["\u00A9 ", new Date().getFullYear(), " Triplejack LLC"] })] })] }));
};
